import styled from 'styled-components';
import { Text } from 'components/Typography';
import { getThemeColor } from 'utils/styled';

export const Root = styled(Text).attrs({
  variant: 'adornment',
})`
  color: ${getThemeColor('actionTertiary')};
`;
